<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="60%"
    top="4vh"
  >
    <div class="order_detail">
      <div
        class="ipt_list u-f u-f-ac"
        style="display: flex; align-items: center"
      >
        <!-- <p class="lable u-f u-f-ac">
          <span class="font14 text_danger" style="margin-right: 3px">*</span>
          <span class="font14 text_black">所在区域：</span>
        </p> -->
        <el-cascader
          v-model="addMerFrom.areaCode"
          :options="regionArr"
          @change="handleAreaChange"
        >
        </el-cascader>
        <el-amap-search-box
          id="search"
          class="search-box"
          style="display: inline-block;margin-left: 20px"
          :search-option="searchOption"
          :on-search-result="onSearchResult"
        />
      </div>
      <!-- <div class="ipt_list u-f u-f-ac">
        <p class="lable u-f u-f-ac">
          <span class="font14 text_danger" style="margin-right: 3px">*</span>
          <span class="font14 text_black">地址：</span>
        </p>
        <el-input
          v-model="addMerFrom.address"
          @change="enterAddress"
          placeholder="请输入地址"
        ></el-input>
      </div> -->

      <!-- <div class="txt_list u-f u-f-ac">
        <p class="lable u-f u-f-ac">
          <span class="font14 text_danger" style="margin-right: 3px">*</span>
          <span class="font14 text_black">经纬度：</span>
        </p>
        <span class="font14 text_black">{{
          addMerFrom.lng ? addMerFrom.lng + "," + addMerFrom.lat : ""
        }}</span>
      </div> -->
      <div class="map_box u-f" style="margin-top: 20px">
        <el-amap
          ref="map"
          style="width: 100%; height: 340px"
          vid="amapDemo"
          :amap-manager="mapFrom.amapManager"
          :center="mapFrom.center"
          :zoom="mapFrom.zoom"
          :events="mapFrom.events"
        >
          <el-amap-marker
            v-for="marker in markers"
            :position="marker.position"
          ></el-amap-marker>
        </el-amap>
      </div>
      <p class="lable u-f">
        <span class="font14 text_black">{{ addMerFrom.address }}</span>
      </p>
    </div>
    <div class="btnBox">
      <el-button size="medium" type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { regionData, codeToText } from "element-china-area-data";
let marker;
import { AMapManager } from "vue-amap";
import VueAMap from "vue-amap";
let amapManager = new VueAMap.AMapManager();

debugger;
export default {
  data() {
    let that = this;
    return {
      regionArr: regionData,
      dialogVisible: this.value, //弹框显隐
      markers: [],
      addMerFrom: {
        merchant: "",
        areaCode: ["44", "4403", "440305"],
        area: "广东省深圳市南山区",
        address: "",
        lng: "113.923552",
        lat: "22.528499",
      },
      // 地图搜索对象
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      mapFrom: {
        amapManager,
        zoom: 15,
        center: [113.923552, 22.528499],
        events: {
          click: (e) => {
            let cen = [e.lnglat.lng, e.lnglat.lat];
            that.mapFrom.center = cen;
            that.addMerFrom.lng = e.lnglat.lng;
            that.addMerFrom.lat = e.lnglat.lat;
            if (this.markers.length) {
              this.markers[0].position = cen;
            } else {
              this.markers.push({
                position: cen,
              });
            }
            that.getAdress(cen);
          },
        },
      },
    };
  },
  props: {
    value: Boolean,
  },
  methods: {
    // 打开弹框
    revealShow() {
      this.dialogVisible = true;
    },
    // 地图搜索回调
    onSearchResult(pois) {
      this.markers = [];
      let latSum = 0;
      let lngSum = 0;
      console.log("地图回调", pois);
      if (pois.length > 0) {
        pois.forEach((poi, index) => {
          const { lng, lat } = poi;
          if (index === 0) {
            lngSum = lng;
            latSum = lat;
            const obj = {
              position: [poi.lng, poi.lat],
              text: poi.name,
              offset: [0, 30],
            };
            this.markers.push(obj);
            console.log("地图搜索回调", poi);
            this.addMerFrom.orgAddr = poi.name;
            this.addMerFrom.lat = poi.lat ? poi.lat.toString() : "";
            this.addMerFrom.lon = poi.lng ? poi.lng.toString() : "";
          }
        });
        this.mapFrom.center = [lngSum, latSum];
        this.getAdress([lngSum, latSum])
      }
    },
    handleAreaChange(val) {
      let str = "";
      for (let item of val) {
        str += codeToText[item];
      }
      this.addMerFrom.areaCode = val;
      this.addMerFrom.area = str;
      this.geoCode(str);
    },
    enterAddress(val) {
      this.geoCode(this.addMerFrom.area + val);
    },
    geoCode(address) {
      AMap.plugin("AMap.Geocoder", () => {
        let geocoder = new AMap.Geocoder();
        geocoder.getLocation(address, (status, result) => {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location;
            this.addMerFrom.lng = lnglat.lng;
            this.addMerFrom.lat = lnglat.lat;
            this.mapFrom.center = [lnglat.lng, lnglat.lat];
          }
        });
      });
    },
    getAdress(cen) {
      AMap.plugin("AMap.Geocoder", () => {
        let geocoder = new AMap.Geocoder();
        geocoder.getAddress(cen, (status, result) => {
          if (status === "complete" && result.regeocode) {
            let address = result.regeocode.formattedAddress;
            let adcode = result.regeocode.addressComponent.adcode;
            let areaCode = [adcode.slice(0, 2), adcode.slice(0, 4), adcode];
            this.addMerFrom.areaCode = areaCode;
            let obj = this.handleAddress(address);
            let str = "";
            for (let item of areaCode) {
              str += codeToText[item];
            }
            this.addMerFrom.area = str;
            this.addMerFrom.address = obj.address;
          }
        });
      });
    },
    handleAreaCode(adcode) {
      let arr = [];
      let two = adcode.slice(0, 2);
      if (two == "81" || two == "82") {
        //香港和澳门
        arr[0] = adcode.slice(0, 2) + "0000";
        arr[1] = adcode;
      } else {
        arr[0] = adcode.slice(0, 2) + "0000";
        arr[1] = adcode.slice(0, 4) + "00";
        arr[2] = adcode;
      }
      return arr;
    },
    handleAddress(add5) {
      let reg = /.+?(省|市|自治区|自治州|县|区)/g;
      let areaArr = add5.match(reg);
      if (areaArr.length > 3) {
        areaArr = areaArr.splice(0, 3);
      }
      let area = "";
      for (let item of areaArr) {
        area += item;
      }
      let address = add5.substring(area.length);
      return { area, address };
    },
    // 确认
    confirm() {
      this.dialogVisible = false;
      this.$emit("confirmOn", this.addMerFrom.area, this.addMerFrom.address,this.addMerFrom.lng,this.addMerFrom.lat);
    },
  },
};
</script>

<style>
.btnBox {
  margin-top: 20px;
  display: flex;
  justify-content: right;
}
</style>
